import React, { Component } from 'react';
import {
	Link
} from 'react-router-dom';
import Preloader from '../img/preloader.gif';
import Api from '../config/Api';

class UsersUpdate extends Component {
	constructor(props) {
		super(props);
		this.state = {
			token: (localStorage.token ? localStorage.token : sessionStorage.token),
			email: '',
			firstname: '',
			lastname: '',
			password: '',
			repeatPassword: '',
			permissions: 'admin',
			isLoading: false,
			showPreloader: false,
			response: '',
			centre: '',
			showCentre: false
		}
	}

	componentWillMount() {
		var self = this;
		Api.getUserInfo(JSON.stringify({ id: this.props.match.params.id, token: this.state.token }), function(response) {
			self.setState({
				email: response.info.email,
				firstname: response.info.first_name,
				lastname: response.info.last_name,
				permissions: response.info.permissions,
				centre: response.info.centre,
				showCentre: response.info.permissions === 'centre' ? true : false,
				ready: true
			});
		});
	}

	onChange = (event) => {
		var name = event.target.name;
		var value = event.target.value;
		var showCentre = false;
		if(name === 'permissions' && value === 'centre') {
			showCentre = true;
		} else if(name === 'permissions' && value === 'admin') {
			showCentre = false;
		} else if(this.state.permissions === 'centre') {
			showCentre = true;
		}
		this.setState({
			[event.target.name]: event.target.value,
			showCentre: showCentre
		});
	}

	onSubmitUpdate = (event) => {
		var self = this;
		event.preventDefault();
		this.setState({
			isLoading: true,
			showPreloader: true,
			response: ''
		}, function() {
			Api.updateUser(JSON.stringify({ id: this.props.match.params.id, email: this.state.email, firstname: this.state.firstname, lastname: this.state.lastname, permissions: this.state.permissions, centre: this.state.centre, token: this.state.token }), function(response) {
				self.setState({
					response: response.response,
					showPreloader: response.showPreloader
				}, function() {
					if(response.errorCode === 0) {
						setTimeout(function(){
							window.location.replace('/users');
						}, 2000);
					} else {
						self.setState({ isLoading: false });
					}
				});
			});
		});
	}

    render() {
    	return(
    		<div className="blockCtr myAccount br10 sh1">
    			<div className="blockHeader br10Top">
    				<Link to={'/users/'} className="backBtn br10TopLeft"><span className="fas fa-chevron-left"></span></Link>
    				<h3>Update User</h3>
    			</div>
    			<div className="blockInfo">
    				<form onSubmit={this.onSubmitUpdate} id="accountForm">
	    				<div className="row">
	    					<div className="col-3 col-m-6" style={{paddingRight: 10, paddingLeft: 10}}>
	    						<input type="text" className="input3 br5 anim1" maxLength="191" name="email" placeholder="E-mail address" onChange={this.onChange} value={this.state.email} />
	    					</div>
	    					<div className="col-3 col-m-6" style={{paddingRight: 10, paddingLeft: 10}}>
	    						<input type="text" className="input3 br5 anim1" maxLength="191" name="firstname" placeholder="First name" onChange={this.onChange} value={this.state.firstname} />
	    					</div>
	    					<div className="col-3 col-m-6" style={{paddingRight: 10, paddingLeft: 10}}>
	    						<input type="text" className="input3 br5 anim1" maxLength="191" name="lastname" placeholder="Last name" onChange={this.onChange} value={this.state.lastname} />
	    					</div>
	    					<div className="col-3 col-m-6" style={{paddingRight: 10, paddingLeft: 10}}>
								<select className="amin1 br5 input3" name="permissions" id="permissions" onChange={this.onChange} value={this.state.permissions}>
									<option value="admin">Adminstrator</option>
									<option value="centre">Centre</option>
								</select>
	    					</div>
	    				</div>
						<div className="row">
							<div className="col-3 col-m-6" style={{paddingRight: 10, paddingLeft: 10}}>
								<select className="amin1 br5 input3" style={{ display: this.state.showCentre ? 'block' : 'none' }} name="centre" id="centre" onChange={this.onChange} value={this.state.centre}>
									<option value="1">1</option>
									<option value="2">2</option>
									<option value="3">3</option>
									<option value="4">4</option>
									<option value="5">5</option>
									<option value="6">6</option>
									<option value="7">7</option>
									<option value="8">8</option>
									<option value="9">9</option>
									<option value="10">10</option>
									<option value="11">11</option>
									<option value="12">12</option>
									<option value="13">13</option>
									<option value="14">14</option>
									<option value="15">15</option>
									<option value="16">16</option>
									<option value="17">17</option>
									<option value="18">18</option>
									<option value="19">19</option>
									<option value="20">20</option>
								</select>
							</div>
						</div>
	    				<div className="row">
	    					<div className="col-6" style={{paddingLeft: 10}}>
	    						<img className="preloader" src={Preloader} alt="Fresenius Preloader" style={{display: (this.state.showPreloader ? 'inline-block' : 'none')}} />
	    						<p className="response">{this.state.response} &nbsp;</p>
	    					</div>
	    					<div className="col-6 ar">
								<input type="submit" className="submit1 br5 anim1" value="Update user" style={{width: '100%', maxWidth: 200, marginRight: 10}} disabled={this.state.isLoading} />
	    					</div>
	    				</div>
	    			</form>
    			</div>
    		</div>
    	);
    }
}

export default UsersUpdate;



// WEBPACK FOOTER //
// ./src/components/UsersUpdate.js